import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { prepararPngEntradasReserva } from './capturarEntradaReserva';

// Comparte únicamente los renders de entradas ya emitidas; nunca escribe datos.
export async function prepararArchivosEntradasReserva(entrega, nodos, options = {}) {
  if (!entrega?.items?.length || nodos.length !== entrega.items.length) throw new Error('Faltan renders de entrada. No se enviará una entrega incompleta.');
  return prepararPngEntradasReserva(entrega.items, nodos, options);
}

export async function compartirArchivosEntradasReserva(files, nombreZip = 'entradas.zip') {
  if (!files?.length) throw new Error('No hay imágenes de entradas preparadas.');
  // Se invoca directamente desde el clic: no capturar ni esperar antes de share.
  let admiteArchivos = !!navigator.share;
  try { if (navigator.canShare) admiteArchivos = navigator.canShare({ files }); }
  catch (_) { admiteArchivos = false; }
  if (navigator.share && admiteArchivos) {
    try { await navigator.share({ files }); return 'compartido'; }
    catch (e) { if (e.name === 'AbortError') return 'cancelado'; }
  }
  const zip = new JSZip();
  files.forEach((file) => zip.file(file.name, file));
  const blob = await zip.generateAsync({ type: 'blob' });
  saveAs(blob, nombreZip);
  return 'zip';
}

export async function compartirEntradasReserva(entrega, nodos) {
  return compartirArchivosEntradasReserva(await prepararArchivosEntradasReserva(entrega, nodos));
}
